<ng-container *transloco="let transloco">
  @if(isSendToEmail){
  <div class="relative w-full h-full flex flex-col justify-center items-center gap-[20px]">
    <div class="flex w-full flex-col justify-center items-center">
      <div class="w-full flex flex-col flex-wrap justify-center items-center text-center text-[16px] font-[500]">
        <p class="flex-none">{{ 'We have sent a verification email for account deletion.' | transloco }}</p>
        <div class="flex flex-row gap-2">
          <p>{{ 'Please check' | transloco }}</p>
          <p class="flex-none text-[20px] font-[800]">{{ userEmail }}</p>
          <p>{{ 'to continue.' | transloco }}</p>
        </div>
        <p class="flex-none">{{ '(It may take some time for the email to arrive.)' | transloco }}</p>
      </div>
      <div class="flex w-full flex-row justify-between items-center"></div>
    </div>
    <!-- <div class="flex-none relative w-full h-[55px] flex flex-row gap-[14px]">
        <button class="w-full h-[60px] flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white" (click)="onClickResend()">Resend</button>
        <button class="w-full h-[60px] flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white" (click)="onClickCancel()">Cancel</button>
      </div> -->
  </div>
  } @else {
  <div class="relative w-full h-full flex flex-col justify-center items-center gap-[20px]">
    <div class="w-full flex justify-center items-center p-[10px] text-[36px] font-[800]">{{ userEmail }}</div>
    <div class="flex w-full flex-col justify-center items-center">
      <div class="w-full flex justify-center items-center text-center text-[16px] font-[500]">{{ 'Are you sure you want to delete the account associated with this email?' | transloco }}</div>
      <div class="flex w-full flex-row justify-between items-center"></div>
    </div>

    <div class="mt-5 w-full h-full flex flex-row gap-2">
      <button (click)="onClickDeleteAccount()" class="w-full h-[60px] flex justify-center items-center rounded-lg bg-black text-[16.8px] font-[600] text-white">{{ 'Delete Account' | transloco }}</button>
    </div>
  </div>
  }
</ng-container>
